<template>
  <div 
    v-scrollanim
    :class="[
      'message-row',
      `message-row-${index  + 1}`,
      {
        'message-sent': message.isMe,
        'message-received': !message.isMe,
      }
    ]"
  >
    <!-- Profile -->
    <template v-if="showProfile">
      <div class="avatar">
        <img :src="$getImgUrl(`assets/profiles/profile_${group}.webp`)">
      </div>
    </template>
    
    <div 
      :class="[
        'bubble-wrapper',
        {
          'bubble-wrapper-text-first': message.isMe && message.message
        }
      ]" 
    >
      <div 
        :class="[
          'bubble',
          {
            sticker: !message.message && message.sticker
          }
        ]"
      >
        <template v-if="message.message">{{message.message}}</template>
        <template v-else>
          <img :src="message.sticker" alt="">
        </template>
      </div>
      <div class="timestamp" v-if="message.timestamp"> 
        <span>1</span> {{message.timestamp}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: Number,
    group: String,
    message: Object
  },
  computed: {
    showProfile() {
      return !this.message.isMe && !this.index
    }
  }
}
</script>

<style lang="scss" scoped>

.message-row {
  --avatar-size: 53px;
  --avatar-bubble-gap: 9px;
  --bubble-min-height: 37px;
  --bubble-bg-color: #FFFFFF;
  --sticker-size: 100px;

  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 9px;
  @media screen and (max-width: 768px) {
    --sticker-size: 146px;
  }
  @media screen and (max-width: 540px) {
    --avatar-size: 48px
  }
  @media screen and (max-width: 400px) {
    --avatar-size: 40px;
  }
}

.avatar {
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: calc(var(--avatar-size) * -0.5);
  width: var(--avatar-size);
  height: var(--avatar-size);
  margin-right: var(--avatar-bubble-gap);
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.message-received {
  justify-content: flex-start;
  padding-left: calc(var(--avatar-bubble-gap) + var(--avatar-size));
}

.message-sent {
  justify-content: flex-end;
}

.bubble-wrapper-text-first {
  display: flex;
  flex-direction: column;
  .bubble {
    margin-top: calc(var(--sticker-size) - var(--bubble-min-height));
  }
}

.bubble {
  flex: none;
  display: flex;
  align-items: center;
  min-height: var(--bubble-min-height);
  background-color: var(--bubble-bg-color);
  border-radius: 10px;
  color: #171717;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
}

.bubble.sticker {
  width: var(--sticker-size);
  height: var(--sticker-size);
  padding: 0;
  img {
    width: 100%;
    height: 100%;
  }
}

.timestamp {
  font-size: 11px;
  color: #C2C2C2;
  text-align: right;
  margin-top: 5px;
  span {
    color: #98AFFF;
  }
}


// Animations
.message-row.before-enter {
  opacity: 0;
  transform: translate3d(0, 50%, 0);
  transition: 350ms transform ease-in-out, 350ms opacity linear;
  transition-delay: 500ms;
}
.message-row.enter {
  transform: translate3d(0, 0%, 0);
  opacity: 1;
}

.message-row-1.before-enter {
  transition-delay: 1000ms;
}
.message-row-2.before-enter {
  transition-delay: 1150ms;
}
.message-row-3.before-enter {
  transition-delay: 1300ms;
}
</style>